module.exports = __webpack_public_path__ + "static/town-of-jupiter@2x-3efef4d88c079ca9494885e2f6994dce.png";